import { getToken } from "services/auth/tokenAuth";
import doRequest from "./client";
import { getUserId } from "services/storage/general";
import { EMPLOYABILITY_ENDPOINTS } from "./constants";
import {
    mapAdvisorCalendarRequest,
    mapAdvisorCalendarToUI,
    mapAttendanceRequest,
    mapBaseResponse,
    mapReservationDetailToUI,
    mapSessionRequest
} from "./mappers";

export const requestSearchAdvisorCalendar = async filters => {
    const [result, err] = await doRequest(
        EMPLOYABILITY_ENDPOINTS.ADVISOR_CALENDAR,
        "POST",
        mapAdvisorCalendarRequest({
            ...filters,
            userCode: getUserId()
        }),
        getToken()
    );
    if (err) return null;
    const response = mapBaseResponse(result);
    return response.success
        ? mapAdvisorCalendarToUI(response.data?.semana || response.data)
        : null;
};

export const requestGetAdvisorReservationDetail = async reservationId => {
    const endpoint = `${EMPLOYABILITY_ENDPOINTS.ADVISOR_RESERVATION_DETAIL(reservationId)}?codigoUsuario=${encodeURIComponent(getUserId())}`;
    const [result, err] = await doRequest(endpoint, "GET", null, getToken());
    if (err) return null;
    const response = mapBaseResponse(result);
    return response.success
        ? mapReservationDetailToUI(response.data?.reserva || response.data)
        : null;
};

export const requestTakeAttendance = async (reservationId, attended) => {
    const [result, err] = await doRequest(
        EMPLOYABILITY_ENDPOINTS.ADVISOR_ATTENDANCE(reservationId),
        "POST",
        mapAttendanceRequest({ userCode: getUserId(), attended }),
        getToken()
    );
    if (err) return false;
    return mapBaseResponse(result).success;
};

export const requestGetAdvisorSession = async reservationId => {
    const endpoint = `${EMPLOYABILITY_ENDPOINTS.ADVISOR_SESSION(reservationId)}?codigoUsuario=${encodeURIComponent(getUserId())}`;
    const [result, err] = await doRequest(endpoint, "GET", null, getToken());
    if (err) return null;
    const response = mapBaseResponse(result);
    return response.success ? response.data?.sesion || response.data : null;
};

export const requestCreateAdvisorSession = async (reservationId, session) => {
    const [result, err] = await doRequest(
        EMPLOYABILITY_ENDPOINTS.ADVISOR_SESSION(reservationId),
        "POST",
        mapSessionRequest({ ...session, userCode: getUserId() }),
        getToken()
    );
    if (err) return null;
    const response = mapBaseResponse(result);
    return response.success ? response.data : null;
};

export const requestUpdateAdvisorSession = async (reservationId, sessionId, session) => {
    const [result, err] = await doRequest(
        EMPLOYABILITY_ENDPOINTS.ADVISOR_SESSION_UPDATE(reservationId, sessionId),
        "PUT",
        mapSessionRequest({ ...session, userCode: getUserId() }),
        getToken()
    );
    if (err) return null;
    const response = mapBaseResponse(result);
    return response.success ? response.data : null;
};

export const requestCloseAdvisorReservation = async (reservationId, finalState) => {
    const [result, err] = await doRequest(
        EMPLOYABILITY_ENDPOINTS.ADVISOR_CLOSE(reservationId),
        "POST",
        {
            codigoUsuario: getUserId(),
            estadoFinal: finalState
        },
        getToken()
    );
    if (err) return false;
    return mapBaseResponse(result).success;
};
